export const displayMarkupText = (markup: string) => {
  return markup;
};
